import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { featuredBanners } from '@/mocks/home';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback(
    (index: number) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrent(index);
      setTimeout(() => setIsTransitioning(false), 600);
    },
    [isTransitioning],
  );

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % featuredBanners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const banner = featuredBanners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={banner.image}
          alt={banner.title}
          className="w-full h-full object-cover transition-opacity duration-600"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
      </div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <span className="inline-block px-4 py-1.5 bg-primary-500 text-white text-sm font-medium rounded-full mb-4">
                {banner.tag}
              </span>
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
                {banner.title}
              </h2>
              <p className="text-white/80 text-base md:text-lg mb-8">
                {banner.subtitle}
              </p>
              <Link
                to={banner.link}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer text-base"
              >
                <i className="ri-play-circle-fill text-xl"></i>
                立即观看
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0">
        <div className="flex items-center justify-center gap-2">
          {featuredBanners.map((_, index) => (
            <button
              key={index}
              onClick={() => goTo(index)}
              className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                index === current
                  ? 'bg-white w-8'
                  : 'bg-white/40 hover:bg-white/70'
              }`}
              aria-label={`切换到第${index + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}